<template>
  <div>
    <h2>SIM Information</h2>
    <form @submit.prevent="submitForm">
      <div>
        <label>
          <input type="radio" value="physical" v-model="simType" /> Physical SIM
        </label>
        <label>
          <input type="radio" value="esim" v-model="simType" /> eSIM
        </label>
      </div>
      <div>
        <label>Serial Number (Last 4 Digits)</label>
        <input
          v-model="serial"
          placeholder="XXXX-XXXX-XXXX-XXXX456756756"
          required
        />
      </div>
      <div>
        <label>PUK Code</label>
        <input v-model="puk" placeholder="Enter the PUK Code" required />
      </div>
      <button type="submit">Next</button>
    </form>
  </div>
</template>

<script>
export default {
  name: "SimInfoForm",
  data() {
    return {
      simType: "physical",
      serial: "",
      puk: "",
    };
  },
  methods: {
    submitForm() {
      // Validate and emit event to go to next tab
      if (this.serial && this.puk) {
        this.$emit("next");
      } else {
        alert("Please fill all required fields.");
      }
    },
  },
};
</script>

<style scoped></style>
